const LOAN_URL = `${process.env.API_V4_HOST}/_exclusive/loan`;

export const getLatestLoanApplicationData = ($axios, { productType = '' }) =>
  $axios.$get(`${LOAN_URL}/applications/latest`, { params: { product_type: productType } });
